<div class="content-viewer">
  @if (contentItems.length === 0) {
    <div class="empty">No content available for this module.</div>
  }

  @if (contentItems.length > 0) {
    <div class="slide-header">
      @if (sectionType === 'slideshow') {
        <span class="slide-counter">Slide {{ currentIndex + 1 }} of {{ contentItems.length }}</span>
      }
      @if (currentItem?.caption) {
        <span class="caption">{{ currentItem!.caption }}</span>
      }
    </div>

    <div class="media-area">
      @if (loadingUrl) {
        <div class="media-loading">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      }

      @if (!loadingUrl && currentUrl && currentItem) {
        @if (currentItem.type === 'image') {
          <img class="slide-image" [src]="currentUrl" [alt]="currentItem.title">
        }
        @if (currentItem.type === 'pdf') {
          <iframe class="slide-pdf" [src]="safeUrl" title="{{ currentItem.title }}"></iframe>
        }
        @if (currentItem.type === 'video') {
          <video class="slide-video" controls [src]="currentUrl"
                 (ended)="onVideoEnded()" (error)="onVideoError()">
          </video>
        }
      }

      @if (showDoneOverlay) {
        <div class="done-overlay">
          <mat-icon class="done-icon">check_circle</mat-icon>
          <span>Done</span>
        </div>
      }

      @if (sectionType === 'slideshow') {
        <button mat-icon-button class="slide-arrow slide-arrow-prev"
                (click)="prev()" [disabled]="isFirst" aria-label="Previous slide">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <button mat-icon-button class="slide-arrow slide-arrow-next"
                (click)="next()" [disabled]="isLast" aria-label="Next slide">
          <mat-icon>chevron_right</mat-icon>
        </button>
      }
    </div>

    <div class="slide-title">{{ currentItem?.title }}</div>
  }
</div>
